import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-3114408a")
const _hoisted_1 = { class: "image-form-container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, "照片", -1)
const _hoisted_3 = { class: "img-list" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_image = _resolveComponent("van-image")!
  const _component_van_icon = _resolveComponent("van-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    true
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_van_image, { class: "img-item" }),
            _createVNode(_component_van_image, { class: "img-item" })
          ]),
          _createVNode(_component_van_icon, {
            class: "right-more",
            name: "arrow"
          })
        ], 64))
      : _createCommentVNode("", true)
  ]))
}